const crypto =
  'undefined' != typeof window
    ? window.crypto
    : 'function' == typeof require
    ? require('crypto').webcrypto
    : null
const base64 =
  'undefined' != typeof window
    ? window.btoa
    : (str) => Buffer.from(str, 'utf8').toString('base64')

// Return a cryptographically random set of numBytes bytes as a hex string
export function generateRandomString(numBytes: number): string {
  if (!crypto) {
    throw new Error(
      'No webcrypto instance found, supported runtimes is node.js >= 15 and semi modern browsers'
    )
  }

  const chars = new Uint32Array(numBytes)
  crypto.getRandomValues(chars)
  return Array.from(chars, (c) => ('0' + c.toString(16)).substr(-2)).join('')
}

// Return a SHA256 hash of a string as a hex string
export async function sha256(str: string) {
  if (!crypto) {
    throw new Error(
      'No webcrypto instance found, supported runtimes is node.js >= 15 and semi modern browsers'
    )
  }

  const encoder = new TextEncoder()
  const data = encoder.encode(str)
  const hash = await crypto.subtle.digest('SHA-256', data)
  return [...new Uint8Array(hash)]
    .map((c) => c.toString(16).padStart(2, '0'))
    .join('')
}

const hexStringToByteArray = (hexString: string) =>
  Uint8Array.from(
    [...(hexString || '').matchAll(/.{1,2}/g)].map(([byte]) =>
      parseInt(byte, 16)
    )
  )

// Return a Base64 encoded version of a hex string
export function hexToBase64(hexString: string): string {
  const byteArray = hexStringToByteArray(hexString)
  return base64(String.fromCharCode.apply(null, Array.from(byteArray)))
}

// Return a Base64URL encoded version of a hex string
export function hexToBase64URL(hexString: string): string {
  return hexToBase64(hexString)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}
